import { Home, LayoutGrid, MapPin, SlidersHorizontal, ShoppingCart } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "@context/CartContext.jsx";

const items = [
  { label: "Главная", path: "/", icon: Home, match: (path) => path === "/" },
  {
    label: "Каталог",
    path: "/series",
    icon: LayoutGrid,
    match: (path) =>
      path.startsWith("/series") ||
      path.startsWith("/catalog") ||
      path.startsWith("/in-stock") ||
      path.startsWith("/product"),
  },
  {
    label: "Собрать",
    path: "/configurator",
    icon: SlidersHorizontal,
    match: (path) => path.startsWith("/configurator"),
  },
  {
    label: "Корзина",
    path: "/cart",
    icon: ShoppingCart,
    match: (path) => path.startsWith("/cart"),
    cart: true,
  },
  {
    label: "Контакты",
    path: "/contacts",
    icon: MapPin,
    match: (path) => path.startsWith("/contacts"),
  },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { getTotalItems } = useCart();
  const cartCount = getTotalItems();

  if (location.pathname.startsWith("/admin")) return null;

  return (
    <>
      <div
        className="h-[calc(64px+env(safe-area-inset-bottom))] md:hidden"
        aria-hidden="true"
      />

      <nav
        className="fixed inset-x-0 bottom-0 z-[90] border-t border-black/10 bg-white/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-8px_24px_rgba(15,35,60,0.08)] backdrop-blur-md md:hidden"
        aria-label="Основная мобильная навигация"
      >
        <div className="grid h-16 grid-cols-5 px-1">
          {items.map((item) => {
            const Icon = item.icon;
            const active = item.match(location.pathname);

            return (
              <button
                key={item.path}
                type="button"
                onClick={() => navigate(item.path)}
                className={`relative flex min-w-0 flex-col items-center justify-center gap-1 px-0.5 transition-colors ${
                  active ? "text-[#CF5327]" : "text-[#72777f]"
                }`}
                aria-current={active ? "page" : undefined}
              >
                <span className="relative flex h-6 w-8 items-center justify-center">
                  <Icon size={21} strokeWidth={active ? 2.3 : 1.8} aria-hidden="true" />
                  {item.cart && cartCount > 0 && (
                    <span className="absolute -right-1.5 -top-1.5 flex h-[17px] min-w-[17px] items-center justify-center rounded-full bg-[#CF5327] px-1 text-[9px] font-semibold leading-none text-white">
                      {cartCount > 99 ? "99+" : cartCount}
                    </span>
                  )}
                </span>
                <span className="geist-m w-full truncate text-center text-[10px] leading-none">
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
}
